export abstract class Translator {
    // compatible with ITranslateService.instant
    public abstract instant(
        key: string | null,
        interpolateParams?: any,
        interpolationId?: 'messageformat',
    ): string;
}
